module.exports = __webpack_public_path__ + "img/WOOCOMMERCE_SMALL.7f02d2d6.svg";